export const getChainConnection = (position, allPosition) => {
    let result = [];

    const connections = position.connections.filter((connect) => connect.to !== position.guid);

    if (!connections.length) {
        return result;
    }

    connections.forEach((connection) => {
        result = [...result, allPosition[connection.to]];
        const resultRec = getChainConnection(allPosition[connection.to], allPosition);
        result = [...result, ...resultRec];
    });

    return result;
};

export const getForwardChain = (position, allPositions) => {
    const result = [];
    const seen = new Set();

    const traverse = (pos) => {
        const type0Followers = pos.connections
            .filter((c) => +c.type === 0 && c.from === pos.guid)
            .map((c) => allPositions[c.to])
            .filter(Boolean);

        const type1Followers = pos.connections
            .filter((c) => +c.type === 1 && c.to === pos.guid)
            .map((c) => allPositions[c.from])
            .filter(Boolean);

        [...type0Followers, ...type1Followers].forEach((follower) => {
            if (!seen.has(follower.guid)) {
                seen.add(follower.guid);
                result.push(follower);
                traverse(follower);
            }
        });
    };

    traverse(position);
    return result;
};

export const getBackwardChain = (position, allPositions) => {
    const result = [];
    const seen = new Set();

    const traverse = (pos) => {
        const type0Predecessors = pos.connections
            .filter((c) => +c.type === 0 && c.to === pos.guid)
            .map((c) => allPositions[c.from])
            .filter(Boolean);

        const type1Predecessors = pos.connections
            .filter((c) => +c.type === 1 && c.from === pos.guid)
            .map((c) => allPositions[c.to])
            .filter(Boolean);

        [...type0Predecessors, ...type1Predecessors].forEach((pred) => {
            if (!seen.has(pred.guid)) {
                seen.add(pred.guid);
                result.push(pred);
                traverse(pred);
            }
        });
    };

    traverse(position);
    return result;
};
